import { SIGN_IN_REDIRECT_QUERY_PARAM } from '@/consts/auth.consts';

export const MOBILE_HANDOFF_QUERY_PARAM = 'mobile_handoff';
export const MOBILE_HANDOFF_QUERY_VALUE = 'start';
export const MOBILE_HANDOFF_SESSION_STORAGE_KEY = 'mobile_handoff_requested';

const NEW_USER_WELCOME_QUERY_VALUE = 'new_user';
const NEW_WORKFLOW_QUERY_PARAM = 'new';
const WORKFLOW_LANDING_PATH_REGEX = /^\/flow\/[^/]+$/;

export function hasMobileHandoffMarker(path: string): boolean {
  const url = new URL(path, window.location.origin);
  return url.searchParams.get(MOBILE_HANDOFF_QUERY_PARAM) === MOBILE_HANDOFF_QUERY_VALUE;
}

export function storeMobileHandoffSessionMarker(path: string): void {
  if (hasMobileHandoffMarker(path)) {
    restoreMobileHandoffSessionMarker();
  }
}

export function clearMobileHandoffSessionMarker(): void {
  sessionStorage.removeItem(MOBILE_HANDOFF_SESSION_STORAGE_KEY);
}

export function consumeMobileHandoffSessionMarker(): boolean {
  if (sessionStorage.getItem(MOBILE_HANDOFF_SESSION_STORAGE_KEY) !== MOBILE_HANDOFF_QUERY_VALUE) {
    return false;
  }

  clearMobileHandoffSessionMarker();
  return true;
}

export function restoreMobileHandoffSessionMarker(): void {
  sessionStorage.setItem(MOBILE_HANDOFF_SESSION_STORAGE_KEY, MOBILE_HANDOFF_QUERY_VALUE);
}

export function isMobileSignupHandoffRoute(pathname: string, search: string): boolean {
  const searchParams = new URLSearchParams(search);
  const isNewSignup = searchParams.getAll('welcome').includes(NEW_USER_WELCOME_QUERY_VALUE);
  if (!isNewSignup) return false;

  if (pathname === '/') return true;

  return WORKFLOW_LANDING_PATH_REGEX.test(pathname) && searchParams.get(NEW_WORKFLOW_QUERY_PARAM) === 'true';
}

export function getMobileHandoffActivationPath(): string {
  const searchParams = new URLSearchParams();
  searchParams.set(MOBILE_HANDOFF_QUERY_PARAM, MOBILE_HANDOFF_QUERY_VALUE);
  return `/?${searchParams.toString()}`;
}

export function getMobileSignupHandoffRedirectPath(pathname: string, search: string, hash = ''): string {
  if (WORKFLOW_LANDING_PATH_REGEX.test(pathname)) {
    const searchParams = new URLSearchParams(search);
    if (searchParams.get(NEW_WORKFLOW_QUERY_PARAM) === 'true') {
      searchParams.delete('welcome');
      const queryString = searchParams.toString();
      return `${pathname}${queryString ? `?${queryString}` : ''}${hash}`;
    }
  }

  return getMobileHandoffActivationPath();
}

export function getMobileHandoffUrl(
  appOrigin: string = window.location.origin,
  redirectPath = getMobileHandoffActivationPath(),
): string {
  const signInUrl = new URL('/signin', appOrigin);

  signInUrl.searchParams.set(SIGN_IN_REDIRECT_QUERY_PARAM, redirectPath);

  return signInUrl.toString();
}
